
        import 'DashboardTable.f8f9e5c.css-module'
        export default {"listContainer":"listContainer_DashboardTable_f8f9e5c","table":"table_DashboardTable_f8f9e5c","dateIssued":"dateIssued_DashboardTable_f8f9e5c","link":"link_DashboardTable_f8f9e5c"}
    